import {take, put, fork, select} from 'redux-saga/effects';
import {openModal, closeModal} from '@computerrock/formation-router/sagas';
import {TemporaryRestriction} from '@ace-de/eua-entity-types';
import * as contractPartnerActionTypes from '../contractPartnerActionTypes';
import fetchRequest from '../../application/sagas/fetchRequest';
import modalIds from '../../modalIds';

const editTemporaryRestrictionFlow = function* editTemporaryRestrictionFlow() {
    const {serviceManager} = yield select(state => state.application);
    const partnerManagementService = serviceManager.loadService('partnerManagementService');

    while (true) {
        const {payload} = yield take(contractPartnerActionTypes.INITIATE_EDIT_TEMPORARY_RESTRICTION_FLOW);
        const {contractPartner, temporaryRestrictionId} = payload;

        yield* openModal(modalIds.CP_EDIT_TEMPORARY_RESTRICTION, {temporaryRestrictionId: `${temporaryRestrictionId}`});

        const responseAction = yield take([
            contractPartnerActionTypes.CONFIRM_EDIT_TEMPORARY_RESTRICTION,
            contractPartnerActionTypes.DECLINE_EDIT_TEMPORARY_RESTRICTION,
        ]);

        if (responseAction.type === contractPartnerActionTypes.CONFIRM_EDIT_TEMPORARY_RESTRICTION) {
            const {temporaryRestrictionData} = responseAction.payload;
            yield fork(
                fetchRequest,
                contractPartnerActionTypes.UPDATE_CONTRACT_PARTNER_TEMPORARY_RESTRICTION_REQUEST,
                partnerManagementService.updateContractPartnerTemporaryRestriction,
                {
                    temporaryRestrictionId,
                    temporaryRestrictionDTO: TemporaryRestriction.objectToPatchDTO(temporaryRestrictionData),
                },
            );

            const updateTemporaryRestrictionResponseAction = yield take([
                contractPartnerActionTypes.UPDATE_CONTRACT_PARTNER_TEMPORARY_RESTRICTION_REQUEST_SUCCEEDED,
                contractPartnerActionTypes.UPDATE_CONTRACT_PARTNER_TEMPORARY_RESTRICTION_REQUEST_FAILED,
            ]);

            if (!updateTemporaryRestrictionResponseAction.error) {
                const {response} = updateTemporaryRestrictionResponseAction.payload;

                yield put({
                    type: contractPartnerActionTypes.STORE_CONTRACT_PARTNER_RESTRICTIONS,
                    payload: {
                        contractPartnerId: contractPartner.id,
                        contractPartnerRestrictionDTOs: [response.contractPartnerRestrictionDTO],
                    },
                });
            }
        }

        yield* closeModal(modalIds.CP_EDIT_TEMPORARY_RESTRICTION, {temporaryRestrictionId: `${temporaryRestrictionId}`});
    }
};

export default editTemporaryRestrictionFlow;
